import { useBapApi } from "@/api/useBapApi";
import { useToast } from "@/composables/useToast";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import { approveTeens } from "./approveTeens";
import { teenGeneratedAnimation } from "./teenGeneratedAnimation";

const {
  useToastTransaction,
} = require("@/composables/useToast/useToastTransaction");
const { useWeb3Store } = require("@/store/web3");
const { useOrchestratorContract } = require("@/web3/contracts");

export const resurrectTeen = async function (
  utilityToken,
  resurrectId,
  sacrificeId
) {
  await approveTeens('resurrect the teen');
  const godBull = useWalletCollectionStore().gods.find(
    (god) => god.guild === utilityToken.guild
  );
  if (!godBull) {
    useToast().error({ title: "You don't have God Bull of the same Guild" });
    return;
  }
  const tokenId = utilityToken.id;
  const godId = godBull.id;
  const walletAddress = useWeb3Store().walletAddress;
  const { success, result } = await useBapApi({
    throw: true,
    toast: { error: true },
  }).exec({
    method: "POST",
    url: "/mint/sign/useitem",
    data: {
      wallet: walletAddress,
      bull1: sacrificeId,
      item: tokenId,
      god: godId,
      resurrected: resurrectId,
    },
  });
  if (!success) {
    useToast().error({ text: "Unable to sign transaction. Please try again" });
    throw new Error("Unable to sign transaction", {
      cause: { success, result },
    });
  }
  const contract = useOrchestratorContract(true);

  const response = await useToastTransaction(
    contract.methods.useItem(
      tokenId,
      sacrificeId,
      godId,
      resurrectId,
      result.signature
    ),
    { text: "Teen Resurrection" }
  );

  console.log(response);
  // const teenId = +response.events.TEEN_RESURRECTED.returnValues.newlyMinted;
  await teenGeneratedAnimation(
    resurrectId,
    response.transactionHash,
    "Resurrected Teen"
  );
  useWalletCollectionStore().fetchCollection(true);
  useWeb3Store().update();
};
